/** @flow */
// My Absences
export const GetMyAbsences = "GET_MY_ABSENCES";
export const GetMyAbsencesSuccess = "GET_MY_ABSENCES_SUCCESS";
export const GetMyAbsencesError = "GET_MY_ABSENCES_ERROR";

// My Details
export const ChangePassword = "CHANGE_PASSWORD";
export const ChangePasswordSuccess = "CHANGE_PASSWORD_SUCCESS";
export const ChangePasswordError = "CHANGE_PASSWORD_ERROR";
export const GetContactInfoSchema = "GET_CONTACT_INFO_SCHEMA";
export const GetContactInfoSchemaSuccess = "GET_CONTACT_INFO_SCHEMA_SUCCESS";
export const GetContactInfoSchemaError = "GET_CONTACT_INFO_SCHEMA_ERROR";
export const UpdateContactInfo = "UPDATE_CONTACT_INFO";
export const UpdateContactInfoSuccess = "UPDATE_CONTACT_INFO_SUCCESS";
export const UpdateContactInfoError = "UPDATE_CONTACT_INFO_ERROR";
export const ToggleContactInfoModal = "TOGGLE_CONTACT_INFO_MODAL";
export const ToggleHomePageSettingsModal = "TOGGLE_HOME_PAGE_SETTINGS_MODAL";
export const ToggleChangePasswordModal = "TOGGLE_CHANGE_PASSWORD_MODAL";
export const ToggleAbsenceDetailsModal = "TOGGLE_ABSENCE_DETAILS_MODAL";

// My Absence Stage
export const GetMonitoringHistory = "GET_MONITORING_HISTORY";
export const GetMonitoringHistorySuccess = "GET_MONITORING_HISTORY_SUCCESS";
export const GetMonitoringHistoryError = "GET_MONITORING_HISTORY_ERROR";
export const GetCurrentMonitoringStage = "GET_CURRENT_MONITORING_STAGE";
export const GetCurrentMonitoringStageSuccess = "GET_CURRENT_MONITORING_STAGE_SUCCESS";
export const GetCurrentMonitoringStageError = "GET_CURRENT_MONITORING_STAGE_ERROR";

// My Employees
export const GetNotificationContacts = "GET_NOTIFICATION_CONTACTS";
export const GetNotificationContactsSuccess = "GET_NOTIFICATION_CONTACTS_SUCCESS";
export const GetNotificationContactsError = "GET_NOTIFICATION_CONTACTS_ERROR";
export const SetNotificationContactsSelectedEmployeeId =
  "SET_NOTIFICATION_CONTACTS_SELECTED_EMPLOYEE_ID";

export const GetMyAbsencesSchema = "GET_MY_ABSENCES_SCHEMA";
export const GetMyAbsencesSchemaSuccess = "GET_MY_ABSENCES_SCHEMA_SUCCESS";
export const GetMyAbsencesSchemaError = "GET_MY_ABSENCES_SCHEMA_ERROR";
export const GetMyAbsence = "GET_MY_ABSENCE";
export const GetMyAbsenceSuccess = "GET_MY_ABSENCE_SUCCESS";
export const GetMyAbsenceError = "GET_MY_ABSENCE_ERROR";
